import React from "react";

type SwitchButtonProps = {
  index: number;
  label: string;
  active?: boolean;
  disabled?: boolean;
  onClick: (index: number, active: boolean) => void;
};

const SwitchButton: React.FC<SwitchButtonProps> = ({
  index,
  label,
  active = false,
  disabled = false,
  onClick,
}) => {
  return (
    <label
      key={index}
      className={`flex items-center cursor-pointer space-x-2 ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      <span className="text-sm">{label}</span>
      <div
        className={`relative w-10 h-5 rounded-full transition-colors ${
          active ? "bg-blue-500" : "bg-gray-400"
        }`}
        onClick={() => {
          if (!disabled) {
            onClick(index, !active);
          }
        }}
      >
        <div
          className={`absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow-md transition-transform ${
            active ? "transform translate-x-5" : ""
          }`}
        ></div>
      </div>
    </label>
  );
};

export default SwitchButton;